import React from "react";
import { colors } from "../../colors/color";
import { IconWithText } from "./IconWithText";

export function AgendaItemCounterCompositeIcon(props:{
    agendaitemCount:number
}) {

    let state:'no-agendaitems' | 'has-agendaitems' 
        = 'no-agendaitems';

    if(props.agendaitemCount > 0)
    {
        state = 'has-agendaitems'
    }

    return (
        <>
            {state === 'no-agendaitems' &&
                <APComponent
                    iconVariant="passive"
                    total={{ count: 0, color: colors.text.muted }}
                    tooltipContent="Ingen agendapunkter oprettet"
                />
            }

            {state === 'has-agendaitems' &&
                
                <APComponent
                    iconVariant="default"
                    total={{ count: props.agendaitemCount, color: colors.text.normal }}
                    tooltipContent={`${props.agendaitemCount} agendapunkt(er) oprettet`}
                />
            }
        </>
    );
}

function APComponent(props:{
    iconVariant: 'passive' | 'default'
    total:{ count:number, color:string },
    tooltipContent: string,
}) {
    return (
        <IconWithText tooltipContent={props.tooltipContent} icon="target" variant={props.iconVariant}>
            <span style={{color:props.total.color}}>{props.total.count}</span>
        </IconWithText>
    );
}